export default {
    data: () => ({
        translations: {
            title: {
                el: "Γρήγορη Πληρωμή",
                en: "Fast Payment",
                it: "Pagamento rapido"
            },
            info: {
                el: "Η ενεργοποίηση της 'Γρήγορης πληρωμής' θα επιτρέψει στους πελάτες σας να κάνουν μια άμεση παραγγελία στο κατάστημά σας, ακόμη και χωρίς να επιλέξουν ένα προϊόν. Λάβετε υπόψη οτι για να ενεργοποιηθεί η 'Γρήγορη πληρωμή', πρέπει πρώτα να ενεργοποιήσετε την 'Ηλεκτρονική επεξεργασία πληρωμών' μέσω της καρτέλας 'Επιβράβευση'.",
                en: `
                    Activating "Fast Payment" will allow customers to make an instant 
                    order to your store even without choosing a product. Keep in mind 
                    that for "Fast Payment" to be activated, you first need to activate 
                    the "Online Payment Processing" through the "Reward" tab.
                `,
                it: "L'attivazione del 'Pagamento rapido' permetterà ai clienti di fare un ordine istantaneo al tuo negozio anche senza scegliere un prodotto. Tieni presente che per attivare il 'Pagamento rapido', devi prima attivare l''Elaborazione del pagamento online' attraverso la scheda 'Ricompensa'."
            },
            toggle: {
                el: "Ενεργοποίηση Γρήγορης Πληρωμής",
                en: "Activate Fast Payment",
                it: "Abilita il pagamento rapido"
            },
            on: {
                el: "Ενεργό",
                en: "On",
                it: "Sopra"
            },
            off: {
                el: "Ανενεργό",
                en: "Off",
                it: "Off"
            }
        }
    })
};
